import { useEffect } from 'react';

import { MAX_COOKIE_LENGTH_IN_DAYS } from '@domain/auth/tokenStorage';
import { UNIVERSAL_ENV_VARS } from '@config/environmentVariables';
import { getAmplitudeInstance } from '@domain/analytics/getAmplitudeInstance';
import { isBrowser } from '@lib/environment/isBrowser';

export function useInitializeAmplitude(): void {
  useEffect(() => {
    if (isBrowser() && getAmplitudeInstance() !== null) {
      getAmplitudeInstance()!.init(UNIVERSAL_ENV_VARS.AMPLITUDE_KEY, undefined, {
        platform: 'Mykiss',
        cookieExpiration: MAX_COOKIE_LENGTH_IN_DAYS,
        includeGclid: true,
        includeFbclid: true,
        includeUtm: true,
        includeReferrer: true,
        disableCookies: true,
      });
    }
  }, []);
}
